import React from "react";
import SVG_IC_GO from "../../../../assets/images/vector/components/ProValue/ic_go.svg";
import ScreenFull from "../../../common/UI/ScreenFull";
import Description from "./Description";
import TrackedLink from "../../../Analytics/TrackedLink";

const Item = ({ screen, buttons, title, isNumberedList, text, index }) => {
  const itemNumber = index + 1;
  return (
    <div className={`PgESM-PV-item PgESM-PV-item_i${itemNumber}`}>
      <Description
        title={title}
        text={text}
        itemNumber={itemNumber}
        isNumberedList={isNumberedList}
      />
      <div className={`PgESM-PV-S PgESM-PV-S_s${itemNumber}`}>
        <ScreenFull screen={screen} />
        {buttons.map((button, i) => (
          <TrackedLink
            key={button.text}
            classes={`PgESM-PV-B PgESM-PV-B_b${i + 1}`}
            category="main_page"
            action={button.text}
            path={button.path}
            target={button.target}
            showMobileProPopup={button.showMobileProPopup}
          >
            {button.text}
            <img className="PgESM-PV-B__icGo" src={SVG_IC_GO} alt="" />
          </TrackedLink>
        ))}
      </div>
    </div>
  );
};
export default Item;
